import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
        overflow: hidden;
        a{
            color: #fff;
            span{
                color: #fff !important;
            }
            &:hover{
                span{
                    color: #ccc !important;
                }
            }
        }
        p{
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                        text-align: left;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        } 
        .subtitle,
        .title{
            font-size: 24px;
            font-weight: 700;
            padding-right: 5px;
        
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        white-space: nowrap;
                    `,
                ],
                "min",
            )}

        }
        .sub-title{
            font-size: 18px;
            font-weight: bold;
            padding-left: 10px;
            position: absolute;
            margin-top: 3px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                        position: relative;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}

        }
        .copyright-txt{
            margin-top: -6px !important;
            text-align: right;
        }
        .footer-logo{
            text-align: left; 
            padding: 15px 20px 0 0;
        }
    `,
    },
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            padding-top: 0;
            padding-bottom: 0;
            > div > div{
                padding-top: 0;
                padding-bottom: 0;
                &:not(:empty) {
                    padding-top: 15px;
                    padding-bottom: 15px;
                }
            }
            img {
                height: 78px;
            }
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div:not(:empty) {
                padding-top: 15px;
                padding-bottom: 15px;
            }
        `
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div:not(:empty) {
                padding-top: 15px;
                padding-bottom: 15px;
            }
        `
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div:not(:empty) {
                padding-top: 15px;
                padding-bottom: 15px;
            }
         `
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div:not(:empty) {
                padding-top: 15px;
                padding-bottom: 15px;
            }
        `
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div:not(:empty) {
                padding-top: 15px;
                padding-bottom: 15px;
            }
        `
    },
    socialLinksGridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div {  
                padding-top: 0;
                padding-bottom: 0;
                > div{ 
                    padding-top: 0;
                    padding-bottom: 0;
                    &:not(:empty) {
                        padding-top: 15px;
                        padding-bottom: 15px;
                    }
                }
            }
        `
    },
    siteMapLinksGridItem: {
        width: 12,
        css: css`
        background: #002469;
        padding: 1px 0;
        >div{
            padding-left: 30px;
            span{
                color: #fff !important;
                float: left;
                span{
                    padding-right: 15px;
                }
            }
        }
    `
    },
    richContentGridItem: {
        width: 12,
        css: css`
        > div > div > div{
            width: 100% !important; 
            *{
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            text-align: left;
                            `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            }
            button{
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            text-align: center;
                            `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            }
            
        }
        img{
            padding-right:8px;
        }
    `
    },
    logoWrapper: {
        css: css`
            width: 110px;
            &:not(:empty){
                padding-top: 15px;
                padding-bottom: 15px;
            }
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.logoGridItem}>
                <StyledWrapper {...styles.logoWrapper}>
                    <Zone zoneName="Logo" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList1GridItem}>
                <Zone zoneName="LinkList1" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <Zone zoneName="LinkList2" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
                <Zone zoneName="LinkList3" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
                <Zone zoneName="LinkList4" contentId={id} />
            </GridItem>
            <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem>
            <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.siteMapLinksGridItem}>
                <Zone zoneName="SiteMapLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
